import { useState } from "react";
import { useQuery } from "react-query";

import useDebounce from "~/shared/hooks/useDebounce";
import { DealersService } from "~/entity/Dealers/api/service";
import { IDealerToAssign } from "~/entity/Dealers/model/schema";
import { UsersService } from "~/entity/Users/api/service";

export const INACTIVE_DEALERS_PAGE_SIZE = 25;

// PASDILER-1921: неактивные (закрывшиеся) ДЦ для закрепления за пользователем.
// GET /dealer/dealers?status=inactive с поиском по наименованию и пагинацией.
// isMy проставляется по уже закреплённым за пользователем ДЦ.
export const useInactiveDealersToAssign = (userId?: string | number) => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(INACTIVE_DEALERS_PAGE_SIZE);
  const debouncedSearch = useDebounce(search);

  const userQuery = useQuery({
    queryKey: ["userDealersToAssign", userId],
    queryFn: () => UsersService.GET.getUser(userId as string),
    refetchOnWindowFocus: false,
    enabled: !!userId,
  });

  const dealersQuery = useQuery({
    queryKey: ["inactiveDealersToAssign", debouncedSearch, page, count],
    queryFn: () =>
      DealersService.GET.getDealerList({
        status: "inactive",
        dealerSearch: debouncedSearch
          ? { dealerName: debouncedSearch }
          : undefined,
        page,
        count,
      }).then((res) => res.data),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });

  const myIds: Record<number, boolean> = {};
  (userQuery.data?.data?.user?.dealers || []).forEach((dealer) => {
    myIds[dealer.id] = true;
  });

  const items: IDealerToAssign[] = (dealersQuery.data?.dealers || []).map(
    (dealer) => ({
      id: dealer.id,
      code: dealer.code,
      INN: dealer.inn,
      DealerName: dealer.dealerName,
      isMy: !!myIds[dealer.id],
      status: dealer.status,
    }),
  );

  const onSearch = (value: string) => {
    setSearch(value);
    setPage(0);
  };

  const onChangeCount = (value: number) => {
    setCount(value || INACTIVE_DEALERS_PAGE_SIZE);
    setPage(0);
  };

  const refetch = () => {
    userQuery.refetch();
    return dealersQuery.refetch();
  };

  return {
    items,
    totalCount: dealersQuery.data?.totalCount ?? 0,
    page,
    setPage,
    count,
    onChangeCount,
    search,
    onSearch,
    loading: dealersQuery.isLoading || userQuery.isLoading,
    isFetching: dealersQuery.isFetching,
    refetch,
  };
};
